// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* AdvancedDatepickerPanel — dark theme expanded dropdown */

.src-js-components-timeframeFilter-advancedDatepickerPanel-module__wrapper--Tt2G1 {
  display: block;
  border: 1px solid #2a3a4a;
  border-radius: 8px;
  background-color: rgba(28, 38, 51, 1);
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.5);
  position: absolute;
  z-index: 1000;
  left: 0;
  margin-top: 4px;
  min-width: 860px;
}

.src-js-components-timeframeFilter-advancedDatepickerPanel-module__container--_gbjL {
  display: flex;
  align-items: flex-start;
  padding: 20px 0;
}

/* Aggregate by column */
.src-js-components-timeframeFilter-advancedDatepickerPanel-module__aggregateCol--tKi53 {
  flex-shrink: 0;
  padding: 0 20px;
}

/* Date range presets column */
.src-js-components-timeframeFilter-advancedDatepickerPanel-module__presetCol--tPFCg {
  flex-shrink: 0;
  padding: 0 20px;
  min-width: 180px;
}

/* Calendar column */
.src-js-components-timeframeFilter-advancedDatepickerPanel-module__calendarCol--zRJXG {
  flex: 1;
  padding: 0 16px;
  min-width: 0;
}

/* Dash between the two calendar date inputs — a CSS-drawn line so width/thickness/color are independently controllable. */
.src-js-components-timeframeFilter-advancedDatepickerPanel-module__calendarDash--QFUdB {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 36px;
  width: 36px;
  flex-shrink: 0;
}

.src-js-components-timeframeFilter-advancedDatepickerPanel-module__calendarDash--QFUdB::before {
  content: '';
  display: block;
  width: 150%;
  height: 1px;
  background-color: #565c63;
}

/* Footer with Cancel / Apply */
.src-js-components-timeframeFilter-advancedDatepickerPanel-module__footer--OSapz {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  gap: 16px;
  padding: 12px 20px;
  
}

.src-js-components-timeframeFilter-advancedDatepickerPanel-module__cancelBtn--FZEYH {
  background: none;
  border: none;
  font-size: 13px;
  color: #A8B0B8;
  cursor: pointer;
  padding: 8px 16px;
}

.src-js-components-timeframeFilter-advancedDatepickerPanel-module__cancelBtn--FZEYH:hover {
  color: rgba(253, 253, 253, 1);
  text-decoration: underline;
}

.src-js-components-timeframeFilter-advancedDatepickerPanel-module__applyBtn--xM6Nt {
  background-color: #FF9600;
  border: none;
  border-radius: 6px;
  padding: 10px 28px;
  font-size: 13px;
  font-weight: 700;
  color: #ffffff;
  cursor: pointer;
  transition: background-color 0.15s ease;
}

.src-js-components-timeframeFilter-advancedDatepickerPanel-module__applyBtn--xM6Nt:hover {
  background-color: #e08800;
}
`, "",{"version":3,"sources":["webpack://./src/js/components/timeframeFilter/advancedDatepickerPanel.module.css"],"names":[],"mappings":"AAAA,2DAA2D;;AAE3D;EACE,cAAc;EACd,yBAAyB;EACzB,kBAAkB;EAClB,qCAAqC;EACrC,yCAAyC;EACzC,kBAAkB;EAClB,aAAa;EACb,OAAO;EACP,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,eAAe;AACjB;;AAEA,wBAAwB;AACxB;EACE,cAAc;EACd,eAAe;AACjB;;AAEA,8BAA8B;AAC9B;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA,oBAAoB;AACpB;EACE,OAAO;EACP,eAAe;EACf,YAAY;AACd;;AAEA,0HAA0H;AAC1H;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,WAAW;EACX,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,cAAc;EACd,WAAW;EACX,WAAW;EACX,yBAAyB;AAC3B;;AAEA,+BAA+B;AAC/B;EACE,aAAa;EACb,yBAAyB;EACzB,mBAAmB;EACnB,SAAS;EACT,kBAAkB;;AAEpB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,cAAc;EACd,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,6BAA6B;EAC7B,0BAA0B;AAC5B;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,uCAAuC;AACzC;;AAEA;EACE,yBAAyB;AAC3B","sourcesContent":["/* AdvancedDatepickerPanel — dark theme expanded dropdown */\n\n.wrapper {\n  display: block;\n  border: 1px solid #2a3a4a;\n  border-radius: 8px;\n  background-color: rgba(28, 38, 51, 1);\n  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.5);\n  position: absolute;\n  z-index: 1000;\n  left: 0;\n  margin-top: 4px;\n  min-width: 860px;\n}\n\n.container {\n  display: flex;\n  align-items: flex-start;\n  padding: 20px 0;\n}\n\n/* Aggregate by column */\n.aggregateCol {\n  flex-shrink: 0;\n  padding: 0 20px;\n}\n\n/* Date range presets column */\n.presetCol {\n  flex-shrink: 0;\n  padding: 0 20px;\n  min-width: 180px;\n}\n\n/* Calendar column */\n.calendarCol {\n  flex: 1;\n  padding: 0 16px;\n  min-width: 0;\n}\n\n/* Dash between the two calendar date inputs — a CSS-drawn line so width/thickness/color are independently controllable. */\n.calendarDash {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  height: 36px;\n  width: 36px;\n  flex-shrink: 0;\n}\n\n.calendarDash::before {\n  content: '';\n  display: block;\n  width: 150%;\n  height: 1px;\n  background-color: #565c63;\n}\n\n/* Footer with Cancel / Apply */\n.footer {\n  display: flex;\n  justify-content: flex-end;\n  align-items: center;\n  gap: 16px;\n  padding: 12px 20px;\n  \n}\n\n.cancelBtn {\n  background: none;\n  border: none;\n  font-size: 13px;\n  color: #A8B0B8;\n  cursor: pointer;\n  padding: 8px 16px;\n}\n\n.cancelBtn:hover {\n  color: rgba(253, 253, 253, 1);\n  text-decoration: underline;\n}\n\n.applyBtn {\n  background-color: #FF9600;\n  border: none;\n  border-radius: 6px;\n  padding: 10px 28px;\n  font-size: 13px;\n  font-weight: 700;\n  color: #ffffff;\n  cursor: pointer;\n  transition: background-color 0.15s ease;\n}\n\n.applyBtn:hover {\n  background-color: #e08800;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wrapper": `src-js-components-timeframeFilter-advancedDatepickerPanel-module__wrapper--Tt2G1`,
	"container": `src-js-components-timeframeFilter-advancedDatepickerPanel-module__container--_gbjL`,
	"aggregateCol": `src-js-components-timeframeFilter-advancedDatepickerPanel-module__aggregateCol--tKi53`,
	"presetCol": `src-js-components-timeframeFilter-advancedDatepickerPanel-module__presetCol--tPFCg`,
	"calendarCol": `src-js-components-timeframeFilter-advancedDatepickerPanel-module__calendarCol--zRJXG`,
	"calendarDash": `src-js-components-timeframeFilter-advancedDatepickerPanel-module__calendarDash--QFUdB`,
	"footer": `src-js-components-timeframeFilter-advancedDatepickerPanel-module__footer--OSapz`,
	"cancelBtn": `src-js-components-timeframeFilter-advancedDatepickerPanel-module__cancelBtn--FZEYH`,
	"applyBtn": `src-js-components-timeframeFilter-advancedDatepickerPanel-module__applyBtn--xM6Nt`
};
export default ___CSS_LOADER_EXPORT___;
